import React from "react";
import { motion } from "framer-motion";

const HeroSection = ({
  title,
  description,
  imageUrl,
  className = "page-header",
  overlay = "auto", // auto | dark | accent | none
  align = "center", // center | left
}) => {

  const textAlign = align === "left" ? "left" : "center";
  const overlayMode = overlay === "auto" ? "dark" : overlay;

  const titleWords = String(title || "").split(" ");
  const descWords = String(description || "").split(" ");

  const titleContainer = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.04, delayChildren: 0.1 },
    },
  };

  const descContainer = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.02, delayChildren: 0.25 },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 8 },
    show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: "easeOut" } },
  };

  return (
    <motion.section
      className={`${className} image-loaded`}
      style={{
        backgroundColor: "var(--card-bg)",
        position: "relative",
      }}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {imageUrl && (
        <motion.div
          aria-hidden
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("${imageUrl}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
          }}
          initial={{ opacity: 1, scale: 1.02 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        />
      )}
      {overlayMode !== "none" && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            background:
              overlayMode === "accent"
                ? "linear-gradient(180deg, rgba(0,0,0,0.2), rgba(0,0,0,0.65)), radial-gradient(60% 60% at 50% 40%, color-mix(in srgb, var(--accent, var(--primary)) 22%, transparent), transparent 60%)"
                : "linear-gradient(180deg, rgba(0,0,0,0.25), rgba(0,0,0,0.65))",
            pointerEvents: "none",
          }}
        />
      )}
      <div style={{ position: "relative", zIndex: 2, textAlign }}>
        <motion.h1
          variants={titleContainer}
          initial="hidden"
          animate="show"
          style={{}}
        >
          {titleWords.map((w, i) => (
            <motion.span
              key={`t-${i}`}
              variants={wordVariants}
              style={{ display: "inline-block", marginRight: i < titleWords.length - 1 ? 8 : 0 }}
            >
              {w}
            </motion.span>
          ))}
        </motion.h1>
        <motion.p
          variants={descContainer}
          initial="hidden"
          animate="show"
          style={{ marginTop: 8 }}
        >
          {descWords.map((w, i) => (
            <motion.span
              key={`d-${i}`}
              variants={wordVariants}
              style={{ display: "inline-block", marginRight: i < descWords.length - 1 ? 6 : 0 }}
            >
              {w}
            </motion.span>
          ))}
        </motion.p>
      </div>
    </motion.section>
  );
};

export default HeroSection;
